import { useGetTrioRoles } from "@/hooks/query/acl/useGetTrioRoles";
import LoadingRoleCard from "../components/LoadingRoleCard";
import RoleCard from "../components/RoleCard";
import TextboxWithFilter from "@/components/common/TextboxWithFilter";
import NoResultWithIcon from "@/components/common/NoResultWithIcon";
import { debounce } from "@/utilize/debounce";
import { useQueryParams } from "@/hooks/general/useQueryParams";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/kit";
import SvgIcon from "@/components/common/SvgIcon";

type TArgumants = {
  search?: string;
  // orderBy?: "name";
  // orderDirection?: TSort;
};

function RoleManagement() {
  const { params, setParams } = useQueryParams<TArgumants>({
    search: "",
    // orderBy: "name",
    // orderDirection: "ASC",
  });
  const { data, isLoading } = useGetTrioRoles(params);
  const roles = data;

  const debounced = debounce((value: string) =>
    setParams({ ...params, search: value }),
  );
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-[90%] gap-6 pt-3 px-5">
      <div className="flex items-center justify-between gap-x-3">
        <TextboxWithFilter
          value={params.search}
          placeholder="Search in name"
          onChange={(e) => debounced(e.target.value)}
        />

        <Button onClick={() => navigate("/acl/add")}>
          <div className="flex items-center gap-x-2">
            <SvgIcon
              iconName="plus"
              fill="fill-white"
              className="w-6 h-6 cursor-pointer"
            />
            Add
          </div>
        </Button>
      </div>
      {!isLoading && !roles?.length ? (
        <div className="flex justify-center items-center h-[100%]">
          <NoResultWithIcon description="no_result_found" />
        </div>
      ) : (
        <div className="grid grid-cols-2 pb-4  overflow-y-auto sm:grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-3">
          {isLoading && <LoadingRoleCard />}
          {roles
            ?.filter((role) => role.name !== "Employee")
            ?.map((role) => (
              <RoleCard role={role} key={role.id} />
            ))}
        </div>
      )}
    </div>
  );
}

export default RoleManagement;
